var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-sm-4 mb-1",staticStyle:{"min-height":"110px"}},[_c('div',{class:`stat-card bg-${_vm.isSuccess ? 'success' : 'info'}`},[_vm._t("title"),_c('div',{staticClass:"font-weight-bold"},[_vm._t("default")],2)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }